import { Col, Row } from 'antd';
import Logo from 'components/Logo';
import StagingTag from 'components/StagingTag';
import { LogoTextStyled } from 'containers/Sidebar/styled';
import React from 'react';

const WizardHeaderLogo: React.FC = () => (
  <Row justify='center' className='gx-layout-sider-header gx-m-0 gx-px-0' style={{ background: '#023365' }}>
    <div className='gx-site-logo'>
      <Row align='middle' justify='center' className='gx-m-0'>
        <StagingTag className='absolute small' />
        <Col>
          <Logo />
        </Col>
        <Col>
          <LogoTextStyled>NotarizeMe</LogoTextStyled>
        </Col>
      </Row>
    </div>
  </Row>
);

export default React.memo(WizardHeaderLogo);
